import React from "react";
import Layout from "../../layout";
import Footer from "../footer/Footer";
import "./faq.css";

function Faqs() {
  return (
    <>
      <Layout>
        <div className=" faqsUI clr mt-5">
          <div className="container">
            <h1>Frequently asked questions</h1>
            <div className="accordion customAccordion" id="accordionExample">
              {/* {FAQ.map((item, index) => (
                <div className="accordion-item" key={index}>
                  <h2 className="accordion-header" id={`heading${item.id}`}>
                    <button
                      className="accordion-button"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target={`#collapse${item.id}`}
                      aria-expanded="true"
                      aria-controls={`collapse${item.id}`}
                    >
                      {item.question}
                    </button>
                  </h2>
                  <div
                    id={`collapse${item.id}`}
                    className={`accordion-collapse collapse`}
                    aria-labelledby={`heading${item.id}`}
                    data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                      <p>{item.answer}</p>
                      <ul>
                        {item.list?.map((list, index) => (
                          <li key={index}>{list}</li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>
              ))} */}

              <div className="accordion-item">
                <h2 className="accordion-header" id="heading21">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapse21"
                    aria-expanded="false"
                    aria-controls="collapse21"
                  >
                    Which wallets can I use to purchase (mint) Monster Zone Land
                    Plots and Condos?
                  </button>
                </h2>
                <div
                  id="collapse21"
                  className="accordion-collapse collapse"
                  aria-labelledby="heading21"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <p>
                      All Ethereum-based wallets supported by Wallet Connect and
                      MetaMask can be used to mint/purchase using TVK (via the
                      Ethereum network only, not Polygon) and ETH.
                    </p>
                    <p>
                      Mint using TVK for a 10% discount (this applies to TVK
                      only).
                    </p>
                    <p>
                      Cardano Land Plots can be purchased/minted using Nami,
                      Flint, Eternl, Gero, and Typhon wallets.
                    </p>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="heading22">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapse22"
                    aria-expanded="false"
                    aria-controls="collapse22"
                  >
                    When will the Monster Zone minting event begin?
                  </button>
                </h2>
                <div
                  id="collapse22"
                  className="accordion-collapse collapse"
                  aria-labelledby="heading22"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <p>The event will begin on the 12th of December.</p>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="heading23">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapse23"
                    aria-expanded="false"
                    aria-controls="collapse23"
                  >
                    Can I purchase (mint) multiple Land Plots and Condos at the
                    same time?
                  </button>
                </h2>
                <div
                  id="collapse23"
                  className="accordion-collapse collapse"
                  aria-labelledby="heading23"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <p>One Land Plot or Condo can be minted per transaction.</p>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="heading24">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapse24"
                    aria-expanded="false"
                    aria-controls="collapse24"
                  >
                    Can I mint Monster Zone Condos through the Virtua mobile
                    app?
                  </button>
                </h2>
                <div
                  id="collapse24"
                  className="accordion-collapse collapse"
                  aria-labelledby="heading24"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <p>
                      Monster Zone Condos can be minted through the Virtua
                      mobile app (as well as through desktop and the MetaMask
                      mobile web browser) from the start of the Land Sale.
                    </p>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="heading25">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapse25"
                    aria-expanded="false"
                    aria-controls="collapse25"
                  >
                    Why is my transaction taking so long to process?
                  </button>
                </h2>
                <div
                  id="collapse25"
                  className="accordion-collapse collapse"
                  aria-labelledby="heading25"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <p>
                      Transactions sometimes take a while to process, due to the
                      nature of blockchain technology and the bandwidth
                      available on a given network at a particular time.
                    </p>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="heading26">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapse26"
                    aria-expanded="false"
                    aria-controls="collapse26"
                  >
                    Where can I sell my Monster Zone Land Plots and Condos?
                  </button>
                </h2>
                <div
                  id="collapse26"
                  className="accordion-collapse collapse"
                  aria-labelledby="heading26"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <p>
                      Ethereum-based Monster Zone Land Plots and Condos can be
                      sold on OpenSea or any other Ethereum-based secondary
                      marketplace, as the item is open.
                      <br />
                      Cardano-based Monster Zone Land Plots can be sold on JPG
                      Store and any other Cardano-based secondary marketplace.
                    </p>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="heading27">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapse27"
                    aria-expanded="false"
                    aria-controls="collapse27"
                  >
                    If I have a Cardano Land Plot in the Monster Zone, will I be
                    able to get Cardonium through it?
                  </button>
                </h2>
                <div
                  id="collapse27"
                  className="accordion-collapse collapse"
                  aria-labelledby="heading27"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <p>
                      Unfortunately not. Cardonium will only be emitted by Land
                      Plots on Cardano Island. Cardonium and other resources
                      will be available for purchase within the in-game
                      marketplace.
                    </p>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="heading28">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapse28"
                    aria-expanded="false"
                    aria-controls="collapse28"
                  >
                    What is a Land Plot?
                  </button>
                </h2>
                <div
                  id="collapse28"
                  className="accordion-collapse collapse"
                  aria-labelledby="heading28"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <p>
                      A Land Plot is a virtual land space which exists as an NFT
                      in the Virtua metaverse.
                    </p>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="heading29">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapse29"
                    aria-expanded="false"
                    aria-controls="collapse29"
                  >
                    What can I use a Land Plot for?
                  </button>
                </h2>
                <div
                  id="collapse29"
                  className="accordion-collapse collapse"
                  aria-labelledby="heading29"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <p>
                      Land Plots will have a number of uses. To begin with, you
                      can build your own unique free Crib – a personalised
                      luxury villa where you can socialise, showcase your NFT
                      collection, and express your authentic self. You can also
                      build unique structures, mine resources to craft items or
                      trade, and later landscape and personalise your
                      environment.
                    </p>
                    <p>
                      We’ve also created multiple paths for fans to generate
                      value in the Monster Zone:
                    </p>
                    <ul>
                      <li>You can sell the resources that your land emits.</li>
                      <li>
                        You can craft new exciting NFTs that other people in the
                        community will want to buy.
                      </li>
                      <li>
                        You can use Land Bots to increase the rate of your
                        resource production, and combine Land Bots with
                        resources to create rare items.
                      </li>
                      <li>
                        Landowners who hold medium-sized and larger Land Plots
                        will get 5% of revenue made from primary sales of
                        generative monster drops (which will be assigned to a
                        treasury specifically dedicated to the Monster Zone).
                      </li>
                      <li>
                        Gigaplot holders can build one Condo Tower on their Land
                        Plot, containing a maximum of 500 Condos available to
                        sell (including a 50% revenue share with Virtua).
                      </li>
                      <li>
                        We will also have special events, during which new items
                        can be discovered.
                      </li>
                      <li>
                        There will also be numerous free mints for Land Plot and
                        Condo owners.
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="heading30">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapse30"
                    aria-expanded="false"
                    aria-controls="collapse30"
                  >
                    Which Land Plot sizes are available, and how do the
                    different sizes of land benefit me?
                  </button>
                </h2>
                <div
                  id="collapse30"
                  className="accordion-collapse collapse"
                  aria-labelledby="heading30"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <p>
                      Monster Zone Land Plots come in four different sizes:
                      Small, Medium, Large, and Giga.
                    </p>
                    <p>
                      Larger Land Plot sizes allow larger structures to be
                      placed on those plots. A small Land Plot may only have
                      space for a Crib, while a large Land Plot could have
                      enough space for a skyscraper – and Gigaplot owners can
                      even build a Condo Tower on their land! Different
                      attributes for structures and customisations will be
                      unlocked over time. Also, exclusive events may only be
                      unlocked by certain landowners.
                    </p>
                    <p>
                      Landowners who hold medium-sized and larger Land Plots
                      will get 5% of revenue made from primary sales of
                      generative monster drops (which will be assigned to a
                      treasury specifically dedicated to the Monster Zone).
                    </p>
                    <p>
                      After each drop, the treasury will be made available for
                      claims by qualifying land owners via a claim portal.
                      Payments will be sent to the users’ connected wallet
                      addresses, and paid in $TVK or $ADA (using a spot
                      conversion).
                    </p>
                    <p>The treasury will be distributed as per the below:</p>
                    <ul>
                      <li>
                        Medium Land Plot Holders: 70% (shared between 1,950
                        plots)
                      </li>
                      <li>
                        Large Land Plot Holders: 28% (shared between 860 plots)
                      </li>
                      <li>Gigaplot Holders: 2% (shared between 2 plots)</li>
                    </ul>
                    <br />
                    <p>
                      Gigaplot holders are entitled to build one Condo Tower of
                      limited size on their Land Plot, containing a maximum of
                      500 Condos available to sell (including a 50% revenue
                      share with Virtua).
                    </p>
                    <p>
                      Condo Tower building permits must be claimed within 12
                      months of Gigaplot purchase, and must then be converted
                      into a build within 6 months of the claim.{" "}
                    </p>
                    <p>
                      In order to build a Condo Tower, the Gigaplot landowner
                      must have the required resources and Builder Land Bots.
                    </p>
                    <p>
                      Gigaplot landowners also get all the Land Bots for FREE.
                    </p>
                    <p>
                      All landowners will also receive an exclusive FREE Starter
                      Crib – a one-room NFT villa where you can showcase your
                      NFTs. Only landowners will receive Starter Cribs.
                    </p>
                    <p>
                      Starter Cribs come in three sizes (Small, Medium, and
                      Large), which correspond to the size of the Land Plot in
                      question. Gigaplot holders will receive a large Crib.
                    </p>
                    <p>
                      Over time, it will be possible for landowners to improve
                      their Cribs by adding crafted items within the Crib, or by
                      purchasing an upgrade (or a new Crib) from the Virtua
                      marketplace.
                    </p>
                    <p>
                      The Virtua platform will allow your Crib to be linked to a
                      particular Land Plot, so that the Crib can be
                      represented/navigated visually in the Virtua metaverse.
                      The ultimate goal is to walk out of the Crib, see it from
                      outside, and be in the metaverse – and this functionality
                      will be introduced during a future phase of our metaverse
                      development.
                    </p>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="heading31">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapse31"
                    aria-expanded="false"
                    aria-controls="collapse31"
                  >
                    What are Condos?
                  </button>
                </h2>
                <div
                  id="collapse31"
                  className="accordion-collapse collapse"
                  aria-labelledby="heading31"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <p>
                      Monster Zone Condos enable community members to live in
                      the Virtua metaverse and have fun without paying for an
                      entire Land Plot. Condos are predesigned apartments that
                      can be customised within specific parameters. Owning a
                      Condo provides access to the amazing events, games, and
                      activations that will take place in the Monster Zone,
                      making you a key member of the community.
                    </p>
                    <p>
                      Condos do not emit resources, and therefore you can only
                      craft if you purchase resources from public markets.
                      However, owning a Condo gives you another lifestyle
                      focused on enjoying and exploring the environment and
                      community.
                    </p>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="heading32">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapse32"
                    aria-expanded="false"
                    aria-controls="collapse32"
                  >
                    What is a Land Plot card?
                  </button>
                </h2>
                <div
                  id="collapse32"
                  className="accordion-collapse collapse"
                  aria-labelledby="heading32"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <p>
                      A Monster Zone Land Plot card contains information about
                      each Land Plot and its attributes. Each Land Plot card
                      will have attributes such as resources, Game Cubes,
                      Relics, and Loot Boxes – and slots for NPCs and Land Bots.
                    </p>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="heading33">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapse33"
                    aria-expanded="false"
                    aria-controls="collapse33"
                  >
                    What are land attributes?
                  </button>
                </h2>
                <div
                  id="collapse33"
                  className="accordion-collapse collapse"
                  aria-labelledby="heading33"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <p>
                      Users will be able to get certain rewards, drops, and
                      upgrades on their Land Plots, based upon the resource
                      rarity they possess. Users will also be able to increase
                      resource emission and create new NFTs using Land Bots
                      (which you can learn about{" "}
                      <a href="https://landbots.virtua.com/" target={"_blank"}>
                        {" "}
                        here{" "}
                      </a>
                      ).
                    </p>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="heading34">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapse34"
                    aria-expanded="false"
                    aria-controls="collapse34"
                  >
                    Can I choose the location of my Land Plot?
                  </button>
                </h2>
                <div
                  id="collapse34"
                  className="accordion-collapse collapse"
                  aria-labelledby="heading34"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <p>
                      Yes – you’ll be able choose the location of your Land Plot
                      during the minting process.
                    </p>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="heading35">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapse35"
                    aria-expanded="false"
                    aria-controls="collapse35"
                  >
                    Will the Land Plots come with buildings? If not, how do
                    buildings get added?
                  </button>
                </h2>
                <div
                  id="collapse35"
                  className="accordion-collapse collapse"
                  aria-labelledby="heading35"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <p>
                      Yes. Landowners will get a free Crib. More advanced
                      structures will be purchasable and earned using resources
                      and Land Bots. Ultimately, the power is in your hands.
                    </p>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="heading36">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapse36"
                    aria-expanded="false"
                    aria-controls="collapse36"
                  >
                    Can I design my own buildings and put them on my Land Plot?
                  </button>
                </h2>
                <div
                  id="collapse36"
                  className="accordion-collapse collapse"
                  aria-labelledby="heading36"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <p>
                      We’re always considering new ideas, especially when they
                      come from our community – but for now, we have already
                      designed a number of prefab buildings to go on Monster
                      Zone Land Plots.
                    </p>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="heading37">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapse37"
                    aria-expanded="false"
                    aria-controls="collapse37"
                  >
                    Can I use my Land Plot for commercial purposes (e.g.
                    billboard adverts, hosting live streams and concerts, etc)?
                  </button>
                </h2>
                <div
                  id="collapse37"
                  className="accordion-collapse collapse"
                  aria-labelledby="heading37"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <p>
                      This is currently under discussion. We’ll provide updates
                      when they become available.
                    </p>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="heading38">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapse38"
                    aria-expanded="false"
                    aria-controls="collapse38"
                  >
                    Will I be able to rent my land or structures to other users?
                  </button>
                </h2>
                <div
                  id="collapse38"
                  className="accordion-collapse collapse"
                  aria-labelledby="heading38"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <p>
                      We’re currently exploring different options around renting
                      systems, and will provide updates when they become
                      available.
                    </p>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="heading39">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapse39"
                    aria-expanded="false"
                    aria-controls="collapse39"
                  >
                    Can I mint more than one Land Plot / Condo?
                  </button>
                </h2>
                <div
                  id="collapse39"
                  className="accordion-collapse collapse"
                  aria-labelledby="heading39"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <p>
                      There’s no restriction on the number of Land Plots or
                      Condos you can mint per wallet. However, mints are limited
                      to one mint/purchase per transaction.
                    </p>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="heading40">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapse40"
                    aria-expanded="false"
                    aria-controls="collapse40"
                  >
                    What is land rarity, and what are the differences between
                    each rarity?
                  </button>
                </h2>
                <div
                  id="collapse40"
                  className="accordion-collapse collapse"
                  aria-labelledby="heading40"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <p>
                      Land Plots emit resources, which can be crafted into other
                      NFTs. Land ownership also enables the discovery of new
                      items. Once an item has been discovered, after a period of
                      time, anyone can craft it.
                    </p>
                    <h5>
                      <em className="underline">Common</em>
                    </h5>
                    <p>
                      Common land does <strong>not</strong> come with Land Bot
                      slots. With common land, resources are emitted regularly,
                      and you can craft new common NFTs.
                    </p>
                    <h5>
                      <em className="underline">Uncommon</em>
                    </h5>
                    <p>
                      Uncommon land comes with <strong>1 Land Bot slot</strong>.
                      With uncommon land, resources are emitted regularly – and
                      you can add 1 Land Bot to increase the rate of resource
                      emission and craft new uncommon NFTs.
                    </p>
                    <h5>
                      <em className="underline">Rare</em>
                    </h5>
                    <p>
                      Rare land comes with <strong>2 Land Bot slots</strong>.
                      With rare land, resources are emitted regularly – and you
                      can add up to 2 Land Bots to increase the rate of resource
                      emission, and also craft rare items.
                    </p>
                    <h5>
                      <em className="underline">Special</em>
                    </h5>
                    <p>
                      Special land comes with <strong>3 Land Bot slots</strong>.
                      With special land, resources are emitted regularly – and
                      you can add up to 3 Land Bots to increase the rate of
                      resource emission, and also craft special items.
                    </p>
                    <h5>
                      <em className="underline">Legendary</em>
                    </h5>
                    <p>
                      Legendary land comes with{" "}
                      <strong>5 Land Bot slots</strong>. With legendary land,
                      resources are emitted regularly, and you can add up to 5
                      Land Bots to increase the rate of resource emission, and
                      also craft special items.
                    </p>
                    <h5>
                      <em className="underline">Mythical</em>
                    </h5>
                    <p>
                      Mythical land comes with{" "}
                      <strong>14 Land Bot slots</strong>. With mythical land,
                      resources are emitted regularly, and you add up to 14 Land
                      Bots to increase the rate of resource emission of all
                      resources on that Land Plot, and also craft special items.
                    </p>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="heading41">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapse41"
                    aria-expanded="false"
                    aria-controls="collapse41"
                  >
                    Why does common land have no Land Bot slots?
                  </button>
                </h2>
                <div
                  id="collapse41"
                  className="accordion-collapse collapse"
                  aria-labelledby="heading41"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <p>
                      The most powerful feature of any Land Plot is the resource
                      it produces. This powers the Virtua metaverse’s economy,
                      and is the engine for crafting new NFTs. Common land still
                      emits resources, which becomes a compelling reason to own
                      a Land Plot. Although Land Bot slots increase emission
                      rates, Land Plot size is also a factor. A small Land Plot
                      with 2 Land Bots accelerating production might only emit
                      as much as 1 common large Land Plot.
                    </p>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="heading42">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapse42"
                    aria-expanded="false"
                    aria-controls="collapse42"
                  >
                    Can I choose the rarity of my Land Plot?
                  </button>
                </h2>
                <div
                  id="collapse42"
                  className="accordion-collapse collapse"
                  aria-labelledby="heading42"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <p>
                      To make sure that everyone gets a fair chance to mint a
                      high-rarity Land Plot, the rarity of your Land Plot will
                      be revealed after it is minted – landowners will not be
                      able to choose the rarity of their land. This “blind drop”
                      system means that you will get a fair chance at minting a
                      high-rarity Land Plot.
                    </p>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="heading43">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapse43"
                    aria-expanded="false"
                    aria-controls="collapse43"
                  >
                    What is the total number of Land Plots that are available
                    for purchase?
                  </button>
                </h2>
                <div
                  id="collapse43"
                  className="accordion-collapse collapse"
                  aria-labelledby="heading43"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <p>
                      {" "}
                      The Monster Zone contains a total of 5002 Ethereum-based
                      Land Plots and 1000 Ethereum-based Condos
                      (purchasable/mintable using{" "}
                      <a href="https://virtua.com/tvk" target={"_blank"}>
                        TVK
                      </a>{" "}
                      (via the Ethereum network only, not Polygon) or ETH, with
                      a 10% discount on TVK mints only), as well as 500 Cardano
                      Land Plots (purchasable/mintable using ADA).
                    </p>

                    <p>
                      Land in the Virtua metaverse often sells very quickly, so
                      it’s best to stay up to date with our latest mint events
                      and other updates through the Virtua{" "}
                      <a
                        href="https://discord.com/invite/virtua"
                        target={"_blank"}
                      >
                        Discord
                      </a>
                      , and follow us on{" "}
                      <a
                        href="https://twitter.com/virtuametaverse"
                        target={"_blank"}
                      >
                        Twitter
                      </a>
                      .
                    </p>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="heading44">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapse44"
                    aria-expanded="false"
                    aria-controls="collapse44"
                  >
                    Which currencies can I use to purchase land in the Monster
                    Zone?
                  </button>
                </h2>
                <div
                  id="collapse44"
                  className="accordion-collapse collapse"
                  aria-labelledby="heading44"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <p>
                      Monster Zone Land Plots and Condos can be purchased
                      (minted) using{" "}
                      <a href="https://virtua.com/tvk" target={"_blank"}>
                        TVK
                      </a>{" "}
                      (via the Ethereum network only, not Polygon) or ETH (with
                      a 10% discount on TVK mints only) – but we do also have
                      some Cardano Land Plots in the Monster Zone that can be
                      purchased (minted) using ADA.
                    </p>

                    <p>
                      Condos can also be bought via the Virtua mobile app, using
                      our vCredits in-app currency.
                    </p>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="heading45">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapse45"
                    aria-expanded="false"
                    aria-controls="collapse45"
                  >
                    How do I purchase/mint Land Plots?
                  </button>
                </h2>
                <div
                  id="collapse45"
                  className="accordion-collapse collapse"
                  aria-labelledby="heading45"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <p>
                      During our special Land Plot mint events, simply follow
                      the instructions below:
                    </p>
                    <ul>
                      <li>Connect your wallet</li>
                      <li>
                        Choose the Land Plot size you want to buy (Small,
                        Medium, Large, Giga)
                      </li>
                      <li>Follow the prompts</li>
                      <li>Mint your Land Plot</li>
                      <li>
                        You’ll then be able to see your Land Plot’s card in your
                        inventory
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="heading46">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapse46"
                    aria-expanded="false"
                    aria-controls="collapse46"
                  >
                    Why are you using a “blind box” sale?
                  </button>
                </h2>
                <div
                  id="collapse46"
                  className="accordion-collapse collapse"
                  aria-labelledby="heading46"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <p>
                      We wanted to give anyone who buys land an equal and fair
                      chance of owning something special. If we allowed everyone
                      to buy only the rarest of plots, then it could place the
                      rarest plots in the hands of just a few individuals. There
                      is an element of chance, equality, and fairness to this
                      type of distribution.
                    </p>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="heading47">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapse47"
                    aria-expanded="false"
                    aria-controls="collapse47"
                  >
                    Where can I view the Land Plots that I've purchased?
                  </button>
                </h2>
                <div
                  id="collapse47"
                  className="accordion-collapse collapse"
                  aria-labelledby="heading47"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <p>
                      Click on the “Inventory” tab on the webpage. The plot will
                      be displayed there in your inventory.
                    </p>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="heading48">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapse48"
                    aria-expanded="false"
                    aria-controls="collapse48"
                  >
                    What will I receive when I mint my Land Plot?
                  </button>
                </h2>
                <div
                  id="collapse48"
                  className="accordion-collapse collapse"
                  aria-labelledby="heading48"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <p>
                      When you mint your Land Plot, you will receive a Land Plot
                      card containing detailed information about your Land Plot,
                      including its rarity; the resources it contains; the
                      availability of Loot Boxes, Relics, and Game Cubes; and
                      how many slots are available for Land Bots and NPCs
                      (non-player characters).
                    </p>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="heading49">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapse49"
                    aria-expanded="false"
                    aria-controls="collapse49"
                  >
                    Will the mint be a smart contract or typical address mint?
                  </button>
                </h2>
                <div
                  id="collapse49"
                  className="accordion-collapse collapse"
                  aria-labelledby="heading49"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <p>Typical.</p>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="heading50">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapse50"
                    aria-expanded="false"
                    aria-controls="collapse50"
                  >
                    What is crafting, and how does it help me?
                  </button>
                </h2>
                <div
                  id="collapse50"
                  className="accordion-collapse collapse"
                  aria-labelledby="heading50"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <p>
                      Due to the special nature of the land in the Monster Zone,
                      all Land Plots (but not Condos) emit resources –
                      regardless of rarity.
                    </p>
                    <p>
                      With all resources, you can do something called “crafting”
                      – and all resources can be used for crafting by Land Plot
                      or Condo owners (Condo owners must purchase resources on
                      the marketplace in order to do this). <em>All</em>{" "}
                      resource types enable you to craft NFT items.
                    </p>
                    <p>What you are able to craft with resources depends on:</p>

                    <ul>
                      <li>The amount of a given resource that you own </li>
                      <li>
                        The type of resources you own (different resources can
                        be crafted into different NFTs)
                      </li>
                      <li>The type of Land Bot you have</li>
                      <li>
                        The number of Land Bot slots you have on your land
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="heading51">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapse51"
                    aria-expanded="false"
                    aria-controls="collapse51"
                  >
                    What are Land Bots?
                  </button>
                </h2>
                <div
                  id="collapse51"
                  className="accordion-collapse collapse"
                  aria-labelledby="heading51"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <p>
                      You can now learn all about our Land Bots through their
                      dedicated web page{" "}
                      <a href="https://landbots.virtua.com/" target={"_blank"}>
                        here
                      </a>
                      .
                    </p>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="heading52">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapse52"
                    aria-expanded="false"
                    aria-controls="collapse52"
                  >
                    What are resources, and what can I do with them?
                  </button>
                </h2>
                <div
                  id="collapse52"
                  className="accordion-collapse collapse"
                  aria-labelledby="heading52"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <p>
                      All land in the Monster Zone emits resources, and you can
                      increase their rate of emission with Land Bots.
                    </p>
                    <p>There are 7 resources in the Monster Zone:</p>
                    <ul>
                      <li>Wood</li>
                      <li>Obsidian</li>
                      <li>Radia</li>
                      <li>Gold</li>
                      <li>Spirit Silk</li>
                      <li>Aquions</li>
                      <li>aDNA</li>
                    </ul>
                    <p>
                      Resources can be sold on a marketplace, or crafted into
                      NFTs. Land Bots enable crafting of even <em>rarer</em>{" "}
                      NFTs. Different resources are emitted at different rarity
                      levels, and some resources are rarer than others.
                      Sometimes, combining Land Bots and using certain
                      combinations may create ultra-rare resources and
                      collectibles.
                    </p>
                  </div>
                </div>
              </div>
              {/* <div className="accordion-item">
                <h2 className="accordion-header" id="heading53">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapse53"
                    aria-expanded="false"
                    aria-controls="collapse53"
                  >
                    How are land resources different from one another?
                  </button>
                </h2>
                <div
                  id="collapse53"
                  className="accordion-collapse collapse"
                  aria-labelledby="heading53"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <p>
                      Land Plots emit valuable and usable resources. Some
                      resources are scarce, while others are common, and the
                      resources that a Land Plot emits will depend on the rarity
                      of that Land Plot.
                    </p>
                  </div>
                </div>
              </div> */}
              <div className="accordion-item">
                <h2 className="accordion-header" id="heading54">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapse54"
                    aria-expanded="false"
                    aria-controls="collapse54"
                  >
                    How do I generate value in the Monster Zone?
                  </button>
                </h2>
                <div
                  id="collapse54"
                  className="accordion-collapse collapse"
                  aria-labelledby="heading54"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <p>
                      We have created multiple paths for fans to play to own in
                      the Monster Zone:
                    </p>
                    <ul>
                      <li>You can sell the resources that your land emits.</li>
                      <li>
                        You can craft new exciting NFTs that other people in the
                        community will want to buy.
                      </li>
                      <li>
                        You can use Land Bots to increase the rate of your
                        resource production, and combine Land Bots with
                        resources to create rare items.
                      </li>
                      <li>
                        Landowners who hold medium-sized and larger Land Plots
                        will get 5% of revenue made from primary sales of
                        generative monster drops (which will be assigned to a
                        treasury specifically dedicated to the Monster Zone).
                      </li>
                      <li>
                        Gigaplot holders can build one Condo Tower on their Land
                        Plot, containing a maximum of 500 Condos available to
                        sell (including a 50% revenue share with Virtua).
                      </li>
                      <li>
                        We will also have special events, during which new items
                        can be discovered.
                      </li>
                      <li>
                        There will also be numerous free mints for Land Plot and
                        Condo owners.
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="heading55">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapse55"
                    aria-expanded="false"
                    aria-controls="collapse55"
                  >
                    When will Monster Zone / Virtua Island users be able to
                    access and explore the outside spaces?
                  </button>
                </h2>
                <div
                  id="collapse55"
                  className="accordion-collapse collapse"
                  aria-labelledby="heading55"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <p>
                      Our current focus is inside spaces, with outside spaces to
                      come after that. We want to ensure that we roll out a
                      truly amazing metaverse experience, and will provide
                      development updates on an ongoing basis.
                    </p>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="heading56">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapse56"
                    aria-expanded="false"
                    aria-controls="collapse56"
                  >
                    What is a Crib?
                  </button>
                </h2>
                <div
                  id="collapse56"
                  className="accordion-collapse collapse"
                  aria-labelledby="heading56"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <p>
                      Cribs are high-fidelity personal spaces where you can
                      establish your home in the Monster Zone, store and
                      showcase your NFTs, decorate/theme your space, and hang
                      out in the metaverse.
                    </p>
                    <p>
                      Over time, we’ll add more and more utility to these
                      spaces, including social features and teleportation to
                      other inside spaces within the Virtua metaverse.
                    </p>

                    <p>
                      The starter Cribs will be single-room villas of different
                      designs and sizes, based on the size and shape of your
                      Land Plot – and <strong>they will be free</strong>. Cribs
                      will be NFTs that can be linked to your land. We will also
                      introduce purchasable NFTs, so you can upgrade and change
                      your Crib to suit your preferences.
                    </p>

                    <p>
                      There will be a Crib Event to claim your free Crib in the
                      future.
                    </p>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="heading57">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapse57"
                    aria-expanded="false"
                    aria-controls="collapse57"
                  >
                    Will the Cribs be free?
                  </button>
                </h2>
                <div
                  id="collapse57"
                  className="accordion-collapse collapse"
                  aria-labelledby="heading57"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <p>
                      Starter Cribs will be free. Upgraded Cribs and new designs
                      will be introduced in the future, and will be available to
                      buy and trade.
                    </p>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="heading58">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapse58"
                    aria-expanded="false"
                    aria-controls="collapse58"
                  >
                    Will the Cribs be NFTs?
                  </button>
                </h2>
                <div
                  id="collapse58"
                  className="accordion-collapse collapse"
                  aria-labelledby="heading58"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <p>Yes.</p>
                  </div>
                </div>
              </div>

              <div className="accordion-item">
                <h2 className="accordion-header" id="heading59">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapse59"
                    aria-expanded="false"
                    aria-controls="collapse59"
                  >
                    What assets will I be able to produce from crafting using
                    resources?
                  </button>
                </h2>
                <div
                  id="collapse59"
                  className="accordion-collapse collapse"
                  aria-labelledby="heading59"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <p>
                      We’re allowing crafting to happen at all rarities. Certain
                      items will be legendary items, and you will have to climb
                      a resource tree and need a combination of a certain Land
                      Bot and a certain resource to craft those items. On the
                      other hand, everybody will be able to craft a lot of other
                      items.
                    </p>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="heading60">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapse60"
                    aria-expanded="false"
                    aria-controls="collapse60"
                  >
                    How are land resources different from one another?
                  </button>
                </h2>
                <div
                  id="collapse60"
                  className="accordion-collapse collapse"
                  aria-labelledby="heading60"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <p>
                      Land Plots emit valuable and usable resources. Some
                      resources are scarce, while others are common, and the
                      resources that a Land Plot emits will depend on the rarity
                      of that Land Plot.
                    </p>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="heading61">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapse61"
                    aria-expanded="false"
                    aria-controls="collapse61"
                  >
                    Will resources be available on-chain or off-chain? Can they
                    be traded across other Virtua islands?
                  </button>
                </h2>
                <div
                  id="collapse61"
                  className="accordion-collapse collapse"
                  aria-labelledby="heading61"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <p>
                      Resources are off-chain in order to enable efficient
                      microtransactions, and you’ll be able to share them across
                      the entire Virtua metaverse.
                    </p>
                    <p>
                      To trade resources, you’ll need a Virtua account. When
                      you’re connected as a user and a resource that you hold is
                      linked to you, you’ll be able to use a marketplace to
                      trade resources.
                    </p>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="heading62">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapse62"
                    aria-expanded="false"
                    aria-controls="collapse62"
                  >
                    How will Land Plots generate resources, and how can we
                    create or craft NFTs from them?
                  </button>
                </h2>
                <div
                  id="collapse62"
                  className="accordion-collapse collapse"
                  aria-labelledby="heading62"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <p>
                      Resource emissions will be determined by a formula with
                      monthly emission and resource pool limits. The formula
                      does get increased, based on whether you have a Miner Bot
                      attached to your land or not.
                    </p>

                    <p>
                      It’s important to note that it doesn’t matter if a Miner
                      Bot is legendary or common or what it looks like – they
                      all provide an equal amount of mining boost. This is to
                      avoid creating a “play to win” dynamic, and maintain a
                      fair and equitable metaverse experience.
                    </p>

                    <p>
                      Generated resources will be visible and claimable through
                      the Claim Portal, and Land Plot resource storage limits
                      will be capped. When that storage limit is reached, you’ll
                      need to manually claim your resources before resource
                      collection will continue. Some Land Bots will have a
                      resource auto-claim feature that will automate this
                      process.
                    </p>

                    <p>
                      When you have any type of resource, you’ll be able to
                      craft common items very easily. Anyone who owns a Land Bot
                      can craft common items – even if you don't own a Land Plot
                      – but you will still need to acquire resources through the
                      marketplace to do that.
                    </p>

                    <p>
                      When you have resources, you’ll be able to clearly see
                      which common items you can craft from those resources.
                      Some items might be functional, and others structural.
                    </p>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="heading63">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapse63"
                    aria-expanded="false"
                    aria-controls="collapse63"
                  >
                    Where can I learn more about Virtua and the Virtua
                    metaverse?
                  </button>
                </h2>
                <div
                  id="collapse63"
                  className="accordion-collapse collapse"
                  aria-labelledby="heading63"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <p>
                      We now have an official Virtua wiki, which you can access
                      via Gitbook{" "}
                      <a
                        href="https://virtua.gitbook.io/virtua-wiki/"
                        target={"_blank"}
                      >
                        here
                      </a>
                      . The official (and newly updated) Virtua website can be
                      found{" "}
                      <a href="https://virtua.com/" target={"_blank"}>
                        here
                      </a>
                      , and looks amazing!
                    </p>
                  </div>
                </div>
              </div>

              {/* <div className="accordion-item">
                <h2 className="accordion-header" id="headingOne">
                  <button
                    className="accordion-button"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseOne"
                    aria-expanded="true"
                    aria-controls="collapseOne"
                  >
                    How do I claim plots?
                  </button>
                </h2>
                <div
                  id="collapseOne"
                  className="accordion-collapse collapse"
                  aria-labelledby="headingOne"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <p>
                      First, you will need to connect a{" "}
                      <strong>
                        Cardano-based soft wallet (other types of wallet will
                        not work) that contains your Cardano Island land deeds
                      </strong>
                      , then select the plot you desire. You will then be shown
                      your available deeds that you can utilise to claim your
                      plot.{" "}
                    </p>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="headingMultiPlots">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseMultiPlots"
                    aria-expanded="false"
                    aria-controls="collapseMultiPlots"
                  >
                    Can I claim multiple plots at once?
                  </button>
                </h2>
                <div
                  id="collapseMultiPlots"
                  className="accordion-collapse collapse "
                  aria-labelledby="headingMultiPlots"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <p>
                      After claiming a plot, the user will have to wait
                      approximately 4 to 5 minutes while the transaction is in
                      progress.
                    </p>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="headingTwo">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseTwo"
                    aria-expanded="false"
                    aria-controls="collapseTwo"
                  >
                    What happens if more than one person wants to claim the same
                    land plot?
                  </button>
                </h2>
                <div
                  id="collapseTwo"
                  className="accordion-collapse collapse"
                  aria-labelledby="headingTwo"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <p>
                      Land plots can be reserved one at a time on a
                      first-come-first-served basis during each Land Claim
                      Event. Reserved land plots will show up as greyed-out to
                      other users. However, land plots can only be reserved for
                      claiming for 120 seconds..
                    </p>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="headingThree">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseThree"
                    aria-expanded="false"
                    aria-controls="collapseThree"
                  >
                    Can my land deed be reimbursed?
                  </button>
                </h2>
                <div
                  id="collapseThree"
                  className="accordion-collapse collapse"
                  aria-labelledby="headingThree"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <p>
                      Unfortunately not. Upon claiming a plot, the respective
                      deed is burned, and this action cannot be undone. This is
                      due to the fundamental immutability of blockchain
                      technology.
                    </p>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="headingFour">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseFour"
                    aria-expanded="false"
                    aria-controls="collapseFour"
                  >
                    I have purchased a plot, but it is not showing in my
                    inventory?
                  </button>
                </h2>
                <div
                  id="collapseFour"
                  className="accordion-collapse collapse"
                  aria-labelledby="headingFour"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <p>
                      After you make a successful claim, your plot may still
                      take some time to show up in your inventory, depending on
                      the load being placed on the Cardano blockchain at the
                      time.
                    </p>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="headingFive">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseFive"
                    aria-expanded="false"
                    aria-controls="collapseFive"
                  >
                    Which wallets can I connect?
                  </button>
                </h2>
                <div
                  id="collapseFive"
                  className="accordion-collapse collapse"
                  aria-labelledby="headingFive"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <p>
                      Claiming can be carried out using Typhon, Nami, Eternl,
                      Flint, and Gero.
                    </p>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="headingSix">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseSix"
                    aria-expanded="false"
                    aria-controls="collapseSix"
                  >
                    The Land Claim site is not working on my browser?
                  </button>
                </h2>
                <div
                  id="collapseSix"
                  className="accordion-collapse collapse"
                  aria-labelledby="headingSix"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <p>
                      For the list of supported browsers, please refer to the
                      table below:
                    </p>
                    <div className="table-responsive">
                      <table className="table">
                        <thead>
                          <tr>
                            <th scope="col">Wallets</th>
                            <th scope="col">Chrome</th>
                            <th scope="col">Brave</th>
                            <th scope="col">Edge</th>
                            <th scope="col">Firefox</th>
                            <th scope="col">Safari</th>
                            <th scope="col">Opera</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <th scope="row">Nami</th>
                            <td>Yes</td>
                            <td>Yes</td>
                            <td>Yes</td>
                            <td>No</td>
                            <td>No</td>
                            <td>No</td>
                          </tr>
                          <tr>
                            <th scope="row">Eternl</th>
                            <td>Yes</td>
                            <td>Yes</td>
                            <td>Yes</td>
                            <td>No</td>
                            <td>No</td>
                            <td>Yes</td>
                          </tr>
                          <tr>
                            <th scope="row">Flint</th>
                            <td>Yes</td>
                            <td>Yes</td>
                            <td>Yes</td>
                            <td>No</td>
                            <td>No</td>
                            <td>Yes</td>
                          </tr>
                          <tr>
                            <th scope="row">Gero</th>
                            <td>Yes</td>
                            <td>Yes</td>
                            <td>Yes</td>
                            <td>No</td>
                            <td>No</td>
                            <td>Yes</td>
                          </tr>
                          <tr>
                            <th scope="row">Typhon</th>
                            <td>Yes</td>
                            <td>Yes</td>
                            <td>Yes</td>
                            <td>No</td>
                            <td>No</td>
                            <td>No</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <p>Incase you are using a Mac:</p>
                    <div className="table-responsive">
                      <table className="table">
                        <thead>
                          <tr>
                            <th scope="col">Wallets</th>
                            <th scope="col">Chrome</th>
                            <th scope="col">Brave</th>
                            <th scope="col">Edge</th>
                            <th scope="col">Firefox</th>
                            <th scope="col">Safari</th>
                            <th scope="col">Opera</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <th scope="row">Nami</th>
                            <td>Yes</td>
                            <td>Yes</td>
                            <td>Yes</td>
                            <td>No</td>
                            <td>No</td>
                            <td>No</td>
                          </tr>
                          <tr>
                            <th scope="row">Eternl</th>
                            <td>Yes</td>
                            <td>Yes</td>
                            <td>Yes</td>
                            <td>No</td>
                            <td>No</td>
                            <td>Yes</td>
                          </tr>
                          <tr>
                            <th scope="row">Flint</th>
                            <td>Yes</td>
                            <td>Yes</td>
                            <td>Yes</td>
                            <td>No</td>
                            <td>No</td>
                            <td>Yes</td>
                          </tr>
                          <tr>
                            <th scope="row">Gero</th>
                            <td>Yes</td>
                            <td>Yes</td>
                            <td>Yes</td>
                            <td>No</td>
                            <td>No</td>
                            <td>Yes</td>
                          </tr>
                          <tr>
                            <th scope="row">Typhon</th>
                            <td>Yes</td>
                            <td>Yes</td>
                            <td>Yes</td>
                            <td>No</td>
                            <td>No</td>
                            <td>No</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="headingSeven">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseSeven"
                    aria-expanded="false"
                    aria-controls="collapseSeven"
                  >
                    Why can’t I click/select the plot I want?
                  </button>
                </h2>
                <div
                  id="collapseSeven"
                  className="accordion-collapse collapse"
                  aria-labelledby="headingSeven"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <p>
                      If the plot you are clicking is greyed out on the map, the
                      plot may have already been reserved by another user, or
                      you do not hold the required deed for that plot.
                    </p>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="headingEight">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseEight"
                    aria-expanded="false"
                    aria-controls="collapseEight"
                  >
                    Where can I view my purchased plots?
                  </button>
                </h2>
                <div
                  id="collapseEight"
                  className="accordion-collapse collapse"
                  aria-labelledby="headingEight"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <p>
                      You can view your purchased plots in the “Inventory”
                      section, and by selecting “My Plots” via the filters
                      available at the top left of the Cardano Island map
                      screen.
                    </p>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="headingNine">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseNine"
                    aria-expanded="false"
                    aria-controls="collapseNine"
                  >
                    How can I see my plots on the map?
                  </button>
                </h2>
                <div
                  id="collapseNine"
                  className="accordion-collapse collapse"
                  aria-labelledby="headingNine"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <p>
                      To view only your purchased plots on the map, you can
                      select the “My Plots” option in the filters available at
                      the top left of the Cardano Island map screen.
                    </p>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="headingTen">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseTen"
                    aria-expanded="false"
                    aria-controls="collapseTen"
                  >
                    Can I claim Cardano Island condos during the Land Claim
                    Event?
                  </button>
                </h2>
                <div
                  id="collapseTen"
                  className="accordion-collapse collapse"
                  aria-labelledby="headingTen"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <p>
                      No. The Cardano Island Condo Claim Event will take place
                      separately from the current Land Claim Event, which is for{" "}
                      <strong>Cardano Island land plots only</strong>. We will
                      provide updates about the Condo Claim Event when they
                      become available.
                    </p>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="headingEleven">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseEleven"
                    aria-expanded="false"
                    aria-controls="collapseEleven"
                  >
                    What happens to my land if I miss the Land Claim Event?
                  </button>
                </h2>
                <div
                  id="collapseEleven"
                  className="accordion-collapse collapse"
                  aria-labelledby="headingEleven"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <p>
                      The Land Claim Event will remain open until all land has
                      been claimed. You can still purchase the Land Plots from
                      secondary Cardano NFT marketplaces.
                    </p>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="headingTwelve">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseTwelve"
                    aria-expanded="false"
                    aria-controls="collapseTwelve"
                  >
                    Will there be multiple claiming windows?
                  </button>
                </h2>
                <div
                  id="collapseTwelve"
                  className="accordion-collapse collapse"
                  aria-labelledby="headingTwelve"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <p>
                      Yes. Land Claim Event access will be based on the rarity
                      of your land deeds, and the Land Claim Event will remain
                      open until all land has been claimed.{" "}
                    </p>
                    <p>
                      The Land Claim Event will take place over 5 days, with
                      access scheduled as follows:
                    </p>
                    <ul>
                      <li>Day 1: Legendary Plots (Small, Medium, Large)</li>
                      <li>
                        Day 2: Special and Legendary Plots (Small, Medium,
                        Large)
                      </li>
                      <li>
                        Day 3: Rare, Special, and Legendary Plots (Small,
                        Medium, Large)
                      </li>
                      <li>
                        Day 4: Uncommon, Rare, Special, and Legendary Plots
                        (Small, Medium, Large)
                      </li>
                      <li>
                        Day 5: Plots of all rarities and sizes (Common,
                        Uncommon, Rare, Special, and Legendary rarities; Small,
                        Medium, and Large sizes)
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="headingThirteen">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseThirteen"
                    aria-expanded="false"
                    aria-controls="collapseThirteen"
                  >
                    How will my land plot’s coordinates be stored?
                  </button>
                </h2>
                <div
                  id="collapseThirteen"
                  className="accordion-collapse collapse"
                  aria-labelledby="headingThirteen"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <p>
                      The coordinates of your land plot are mentioned on the
                      Land Plot NFT itself, and you can view them in the
                      inventory whenever your wallet is connected.
                    </p>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="headingFourteen">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseFourteen"
                    aria-expanded="false"
                    aria-controls="collapseFourteen"
                  >
                    What if I keep my plots in a Ledger wallet?
                  </button>
                </h2>
                <div
                  id="collapseFourteen"
                  className="accordion-collapse collapse"
                  aria-labelledby="headingFourteen"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <p>
                      You will need to connect a{" "}
                      <strong>
                        Cardano-based soft wallet (hard wallets and other types
                        of wallet will not work) that contains your Cardano
                        Island land deeds
                      </strong>{" "}
                      in order to participate in the Land Claim Event.
                    </p>
                    <p>
                      Claiming can be carried out using Typhon, Nami, Eternl,
                      Flint, and Gero.
                    </p>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="headingFifteen">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseFifteen"
                    aria-expanded="false"
                    aria-controls="collapseFifteen"
                  >
                    Will I be able to use hard/cold wallets to interact with
                    Cardano Island in the future?
                  </button>
                </h2>
                <div
                  id="collapseFifteen"
                  className="accordion-collapse collapse"
                  aria-labelledby="headingFifteen"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <p>
                      Hard and cold wallets are currently not supported. You
                      will need to connect a{" "}
                      <strong>
                        Cardano-based soft wallet (hard wallets and other types
                        of wallet will not work) that contains your Cardano
                        Island land deeds
                      </strong>{" "}
                      in order to participate in the Land Claim Event.
                    </p>
                    <p>
                      Claiming can be carried out using Typhon, Nami, Eternl,
                      Flint, and Gero.
                    </p>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="headingSixteen">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseSixteen"
                    aria-expanded="false"
                    aria-controls="collapseSixteen"
                  >
                    Do I have to transfer my land deeds to the exact same wallet
                    that I first used to mint my land deeds?
                  </button>
                </h2>
                <div
                  id="collapseSixteen"
                  className="accordion-collapse collapse"
                  aria-labelledby="headingSixteen"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <p>
                      No. You can utilise any of your Cardano wallets (but only
                      those that are supported) that contain the required land
                      deeds in order to claim land plots.
                    </p>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="headingSeventeen">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseSeventeen"
                    aria-expanded="false"
                    aria-controls="collapseSeventeen"
                  >
                    How many land plots can be claimed per wallet?
                  </button>
                </h2>
                <div
                  id="collapseSeventeen"
                  className="accordion-collapse collapse"
                  aria-labelledby="headingSeventeen"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <p>
                      The number of plots claimed per wallet depends entirely on
                      the number of deeds that are contained within that wallet.
                    </p>
                    <p>
                      There is no limit to the number of land plots that can be
                      claimed per wallet.
                    </p>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="headingEighteen">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseEighteen"
                    aria-expanded="false"
                    aria-controls="collapseEighteen"
                  >
                    What’s to stop one user from reserving all of the best land
                    plots at once (e.g. by opening multiple tabs on their
                    browser and selecting a different plot in each tab)?
                  </button>
                </h2>
                <div
                  id="collapseEighteen"
                  className="accordion-collapse collapse"
                  aria-labelledby="headingEighteen"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <p>
                      Land plots can only be claimed on a
                      one-plot-per-transaction basis, and land plots can only be
                      reserved for a maximum of 120 seconds.
                    </p>
                    <p>
                      As each transaction will take more than 120 seconds to be
                      processed by our system and the Cardano blockchain
                      network, it will not be possible for a user to
                      successfully mass-reserve and mass-claim multiple land
                      plots at once. By the time one land plot transaction has
                      been successfully confirmed, the other plot reservations
                      would have expired and those plots would again become
                      available for any user to reserve.
                    </p>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="headingNineteen">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseNineteen"
                    aria-expanded="false"
                    aria-controls="collapseNineteen"
                  >
                    Will my land plot begin emitting resources immediately after
                    claiming?
                  </button>
                </h2>
                <div
                  id="collapseNineteen"
                  className="accordion-collapse collapse"
                  aria-labelledby="headingNineteen"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <p>
                      No. We will provide further updates and information when
                      they become available.
                    </p>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="headingTwenty">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseTwenty"
                    aria-expanded="false"
                    aria-controls="collapseTwenty"
                  >
                    Will there be a queuing system for the Land Claim Event?
                  </button>
                </h2>
                <div
                  id="collapseTwenty"
                  className="accordion-collapse collapse"
                  aria-labelledby="headingTwenty"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <p>
                      No. All users will be able to access the Land Claim portal
                      and claim land at the same time (within their respective
                      rarity time slots).
                    </p>
                  </div>
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </Layout>

      <Footer />
    </>
  );
}

export default Faqs;
